import { AppStreamSDK } from "../../../../utils/AppStreamSDK";
import {
    IToolbarButtonActiveContentType,
    IToolbarButtonProps,
    IToolbarButtonStatefulModalProps,
    IToolbarButtonType,
    NotificationList,
    ToolbarActiveStateContentProps,
    ToolbarContainerItemContent,
    useToolbarCollapseStore,
} from "@amzn/aws-euc-ui";
import React, { memo } from "react";
import { Icon } from "@cloudscape-design/components";
import { ToolbarItemId, ToolbarMode } from "../../../../constants/Toolbar";
import { useTranslation } from "react-i18next";
import { useFilesNotificationStore } from "../../../../hooks/useNotificationStore";
import { FileToolbarItemContent } from "./FileToolbarItemContent";

export const useFileToolbarItem = (
    appStreamSDK: AppStreamSDK,
    toolbarState: string
): IToolbarButtonProps | IToolbarButtonStatefulModalProps => {
    const { t } = useTranslation();
    const notificationList = useFilesNotificationStore(
        (store) => store.notificationList
    );

    const { setCollapsed } = useToolbarCollapseStore();

    const Content = () => {
        return (
            <>
                <NotificationList
                    items={notificationList}
                    ariaLabel={t("notification.list.ariaLabel")}
                />
                <FileToolbarItemContent appStreamSDK={appStreamSDK} />
            </>
        );
    };

    if (toolbarState === ToolbarMode.Docked) {
        return {
            type: IToolbarButtonType.STATEFUL,
            label: t("toolbar.item.files.label"),
            id: ToolbarItemId.FILES,
            icon: <Icon data-testid={"file-explorer-icon"} name="folder" />,
            onClick: () => {
                setCollapsed(false);
            },
            activeStateContentType: IToolbarButtonActiveContentType.MODAL,
            ActiveStateContent: memo(() => <Content />),
            ariaLabelCloseModal: t(
                "toolbar.item.files.content.close.ariaLabel"
            ),
        };
    }

    return {
        type: IToolbarButtonType.STATEFUL,
        activeStateContentType: IToolbarButtonActiveContentType.CONTAINER,
        id: ToolbarItemId.FILES,
        label: t("toolbar.item.files.label"),
        icon: <Icon data-testid={"file-explorer-icon"} name="folder" />,
        onClick: () => {
            setCollapsed(false);
        },
        ActiveStateContent: memo((props: ToolbarActiveStateContentProps) => (
            <ToolbarContainerItemContent
                close={props.close}
                closeButtonAriaLabel={t(
                    "toolbar.item.files.content.close.ariaLabel"
                )}
                closeButtonTitle={t("toolbar.item.content.close.title")}
            >
                <Content />
            </ToolbarContainerItemContent>
        )),
    };
};
